/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/plan.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { PlanServiceUpdateNoteBody } from '../models'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { TrackerCreateNoteRequest } from '../models'
// @ts-ignore
import type { TrackerListNotesResponse } from '../models'
// @ts-ignore
import type { TrackerMyStats } from '../models'
// @ts-ignore
import type { TrackerNote } from '../models'
// @ts-ignore
import type { TrackerPushToStackRequest } from '../models'
// @ts-ignore
import type { TrackerReorderStackRequest } from '../models'
// @ts-ignore
import type { TrackerStackResponse } from '../models'
/**
 * PlanServiceApi - axios parameter creator
 */
export const PlanServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Writes a note. One field, no project and no type: notes are taken during a meeting, and every required field is a reason not to write anything down.
     * @param {TrackerCreateNoteRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceCreateNote: async (
      body: TrackerCreateNoteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('planServiceCreateNote', 'body', body)
      const localVarPath = `/api/v1/tracker/notes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a note for good.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceDeleteNote: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('planServiceDeleteNote', 'id', id)
      const localVarPath = `/api/v1/tracker/notes/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Numbers behind the plan: what was closed per day, how long a task takes, what is late, and how long the current stack would take at that pace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceGetMyStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/plan/stats`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the caller\'s stack, top first. The top item is what they are working on now.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceGetStack: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/plan/stack`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary The caller\'s notes, newest first.
     * @param {boolean} [onlyPending] Leave out notes already turned into tasks.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceListNotes: async (
      onlyPending?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/notes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (onlyPending !== undefined) {
        localVarQueryParameter['onlyPending'] = onlyPending
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Puts a task into the stack. Pushing a task that is already there moves it instead of duplicating it.
     * @param {TrackerPushToStackRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServicePushToStack: async (
      body: TrackerPushToStackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('planServicePushToStack', 'body', body)
      const localVarPath = `/api/v1/tracker/plan/stack`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Takes a task out of the stack by hand. Finishing a task takes it out on its own — this is for changing one\'s mind, not for reporting work done.
     * @param {string} issueKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceRemoveFromStack: async (
      issueKey: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueKey' is not null or undefined
      assertParamExists('planServiceRemoveFromStack', 'issueKey', issueKey)
      const localVarPath = `/api/v1/tracker/plan/stack/{issueKey}`.replace(
        '{issueKey}',
        encodeURIComponent(String(issueKey)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sets the whole order at once. The request must list every task in the stack: a partial order says nothing about where the rest goes.
     * @param {TrackerReorderStackRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceReorderStack: async (
      body: TrackerReorderStackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('planServiceReorderStack', 'body', body)
      const localVarPath = `/api/v1/tracker/plan/stack/reorder`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Edits a note: its text, the \"sorted out\" mark, and the keys of the tasks that came out of it. Absent fields are left alone.
     * @param {string} id
     * @param {PlanServiceUpdateNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceUpdateNote: async (
      id: string,
      body: PlanServiceUpdateNoteBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('planServiceUpdateNote', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('planServiceUpdateNote', 'body', body)
      const localVarPath = `/api/v1/tracker/notes/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PlanServiceApi - functional programming interface
 */
export const PlanServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Writes a note. One field, no project and no type: notes are taken during a meeting, and every required field is a reason not to write anything down.
     * @param {TrackerCreateNoteRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceCreateNote(
      body: TrackerCreateNoteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerNote>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceCreateNote(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceCreateNote']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a note for good.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceDeleteNote(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceDeleteNote(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceDeleteNote']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Numbers behind the plan: what was closed per day, how long a task takes, what is late, and how long the current stack would take at that pace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceGetMyStats(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerMyStats>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceGetMyStats(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceGetMyStats']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the caller\'s stack, top first. The top item is what they are working on now.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceGetStack(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerStackResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceGetStack(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceGetStack']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary The caller\'s notes, newest first.
     * @param {boolean} [onlyPending] Leave out notes already turned into tasks.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceListNotes(
      onlyPending?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListNotesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceListNotes(
        onlyPending,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceListNotes']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Puts a task into the stack. Pushing a task that is already there moves it instead of duplicating it.
     * @param {TrackerPushToStackRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServicePushToStack(
      body: TrackerPushToStackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerStackResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServicePushToStack(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServicePushToStack']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Takes a task out of the stack by hand. Finishing a task takes it out on its own — this is for changing one\'s mind, not for reporting work done.
     * @param {string} issueKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceRemoveFromStack(
      issueKey: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerStackResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceRemoveFromStack(
        issueKey,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceRemoveFromStack']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Sets the whole order at once. The request must list every task in the stack: a partial order says nothing about where the rest goes.
     * @param {TrackerReorderStackRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceReorderStack(
      body: TrackerReorderStackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerStackResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceReorderStack(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceReorderStack']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Edits a note: its text, the \"sorted out\" mark, and the keys of the tasks that came out of it. Absent fields are left alone.
     * @param {string} id
     * @param {PlanServiceUpdateNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planServiceUpdateNote(
      id: string,
      body: PlanServiceUpdateNoteBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerNote>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planServiceUpdateNote(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanServiceApi.planServiceUpdateNote']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PlanServiceApi - factory interface
 */
export const PlanServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Writes a note. One field, no project and no type: notes are taken during a meeting, and every required field is a reason not to write anything down.
     * @param {TrackerCreateNoteRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceCreateNote(
      body: TrackerCreateNoteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerNote> {
      return localVarFp
        .planServiceCreateNote(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a note for good.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceDeleteNote(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .planServiceDeleteNote(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Numbers behind the plan: what was closed per day, how long a task takes, what is late, and how long the current stack would take at that pace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceGetMyStats(options?: RawAxiosRequestConfig): AxiosPromise<TrackerMyStats> {
      return localVarFp.planServiceGetMyStats(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the caller\'s stack, top first. The top item is what they are working on now.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceGetStack(options?: RawAxiosRequestConfig): AxiosPromise<TrackerStackResponse> {
      return localVarFp.planServiceGetStack(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary The caller\'s notes, newest first.
     * @param {boolean} [onlyPending] Leave out notes already turned into tasks.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceListNotes(
      onlyPending?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListNotesResponse> {
      return localVarFp
        .planServiceListNotes(onlyPending, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Puts a task into the stack. Pushing a task that is already there moves it instead of duplicating it.
     * @param {TrackerPushToStackRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServicePushToStack(
      body: TrackerPushToStackRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerStackResponse> {
      return localVarFp
        .planServicePushToStack(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Takes a task out of the stack by hand. Finishing a task takes it out on its own — this is for changing one\'s mind, not for reporting work done.
     * @param {string} issueKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceRemoveFromStack(
      issueKey: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerStackResponse> {
      return localVarFp
        .planServiceRemoveFromStack(issueKey, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Sets the whole order at once. The request must list every task in the stack: a partial order says nothing about where the rest goes.
     * @param {TrackerReorderStackRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceReorderStack(
      body: TrackerReorderStackRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerStackResponse> {
      return localVarFp
        .planServiceReorderStack(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Edits a note: its text, the \"sorted out\" mark, and the keys of the tasks that came out of it. Absent fields are left alone.
     * @param {string} id
     * @param {PlanServiceUpdateNoteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planServiceUpdateNote(
      id: string,
      body: PlanServiceUpdateNoteBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerNote> {
      return localVarFp
        .planServiceUpdateNote(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PlanServiceApi - object-oriented interface
 */
export class PlanServiceApi extends BaseAPI {
  /**
   *
   * @summary Writes a note. One field, no project and no type: notes are taken during a meeting, and every required field is a reason not to write anything down.
   * @param {TrackerCreateNoteRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceCreateNote(body: TrackerCreateNoteRequest, options?: RawAxiosRequestConfig) {
    return PlanServiceApiFp(this.configuration)
      .planServiceCreateNote(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a note for good.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceDeleteNote(id: string, options?: RawAxiosRequestConfig) {
    return PlanServiceApiFp(this.configuration)
      .planServiceDeleteNote(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Numbers behind the plan: what was closed per day, how long a task takes, what is late, and how long the current stack would take at that pace.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceGetMyStats(options?: RawAxiosRequestConfig) {
    return PlanServiceApiFp(this.configuration)
      .planServiceGetMyStats(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the caller\'s stack, top first. The top item is what they are working on now.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceGetStack(options?: RawAxiosRequestConfig) {
    return PlanServiceApiFp(this.configuration)
      .planServiceGetStack(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary The caller\'s notes, newest first.
   * @param {boolean} [onlyPending] Leave out notes already turned into tasks.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceListNotes(
    onlyPending?: boolean,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanServiceApiFp(this.configuration)
      .planServiceListNotes(onlyPending, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Puts a task into the stack. Pushing a task that is already there moves it instead of duplicating it.
   * @param {TrackerPushToStackRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServicePushToStack(body: TrackerPushToStackRequest, options?: RawAxiosRequestConfig) {
    return PlanServiceApiFp(this.configuration)
      .planServicePushToStack(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Takes a task out of the stack by hand. Finishing a task takes it out on its own — this is for changing one\'s mind, not for reporting work done.
   * @param {string} issueKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceRemoveFromStack(issueKey: string, options?: RawAxiosRequestConfig) {
    return PlanServiceApiFp(this.configuration)
      .planServiceRemoveFromStack(issueKey, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Sets the whole order at once. The request must list every task in the stack: a partial order says nothing about where the rest goes.
   * @param {TrackerReorderStackRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceReorderStack(
    body: TrackerReorderStackRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanServiceApiFp(this.configuration)
      .planServiceReorderStack(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Edits a note: its text, the \"sorted out\" mark, and the keys of the tasks that came out of it. Absent fields are left alone.
   * @param {string} id
   * @param {PlanServiceUpdateNoteBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planServiceUpdateNote(
    id: string,
    body: PlanServiceUpdateNoteBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanServiceApiFp(this.configuration)
      .planServiceUpdateNote(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
